import React from 'react';
import { Glyphicon, Alert, Button, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { statusTypes } from "../config/constants";
import { setPasscode } from "../actions";

const ApplicationInformation = (props) => {
    const period = props.periods.find((period) => props.match.params.periodId === period.periodId);
    const hasPasscode = period && period.passcode && period.passcode !== '';
    const { onCreateApplication, dispatch } = props;
    const handlePasscodeChange = (e) => dispatch(setPasscode(e.target.value))
    const getButton = () => {
        const { user, newUser, passcode } = props;
        let currentApplication;
        let canApply = false;
        if (user && user.complete)
            currentApplication = user.applications.find((application) => period.periodId === application.periodId);
        if (!currentApplication)
            canApply = !period.passcode || period.passcode === '' || period.passcode === passcode;
        return user || newUser ?
            currentApplication ?
                (
                    <LinkContainer to={`/form/${currentApplication.periodId}`}>
                        <Button bsStyle="primary">Continue Application</Button>
                    </LinkContainer>
                )
                :
                (
                    <>
                        {hasPasscode &&
                            <FormGroup
                                controlId="passcode"
                                validationState={canApply ? statusTypes.SUCCESS : statusTypes.ERROR} >
                                <ControlLabel>
                                    Passcode
                                </ControlLabel>
                                <FormControl
                                    componentClass="input"
                                    type="text"
                                    value={passcode}
                                    placeholder="Passcode Required"
                                    onChange={handlePasscodeChange}
                                />
                                <FormControl.Feedback />
                            </FormGroup>
                        }
                        <Button onClick={() => onCreateApplication(period.periodId)} disabled={!canApply}>
                            Begin Application
                        </Button>
                    </>
                )
            :
            (
                <Alert bsStyle="warning">
                    <p>
                        You must log in to begin a health sciences application.
                    </p>
                </Alert>
            )
    };

    return (
        <div>
            <h2>{period ? period.name : 'Period not found'}</h2>
            <h3>Application Information</h3>
            <p>
                <Glyphicon glyph="chevron-right" className="info-bullet"/>
                The application requires you to enter detailed information related to your academic history. Please have
                copies of academic transcript(s)
                available before you begin. The information you provide will be used to determine your eligibility for
                the program; <strong>failure to provide
                accurate information will result in disqualification</strong>.
            </p>
            <p>
                <Glyphicon glyph="chevron-right" className="info-bullet"/>
                The application automatically saves your information whenever you finish a page. Click the Save and
                Continue button at any time to have your current information saved.
                As long as you do not Submit, you can return later to finish the application.
            </p>
            <p>
                <Glyphicon glyph="chevron-right" className="info-bullet"/>
                Some application information may be auto populated if you previously submitted an application. Please
                review this information to ensure that it is correct
                and current. If errors in the past disqualified you, be sure you correct the information before you
                submit the application.
            </p>
            <p>
                <Glyphicon glyph="chevron-right" className="info-bullet"/>
                Before you Submit your completed application, please review. Once the application has been submitted,
                you will not be able to make changes. Upon completion,
                you will receive an e-mail confirming receipt of your application.
            </p>
            <Alert bsStyle="warning">
                <p>
                    It is imperative that you follow all directions on the application and ensure all information
                    submitted is correct. Please be aware that incorrect information
                    or information that cannot be verified will result in disqualification.
                </p>
            </Alert>
            {props.userSet &&
                <Alert bsStyle="warning">
                    <p>
                        All correspondence from the college regarding your application will be sent to your Delta
                        College e-mail
                        address:<br/><strong>{props.studentEmail}</strong>.
                    </p>
                </Alert>
            }
            {getButton()}
        </div>
    )
};

export default ApplicationInformation